import { IonContent } from '@ionic/react';
import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  BgImageStyles,
  FooterContainerStyles,
  OverlayGradientStyles,
  PageStyles,
  PageTitleStyles,
} from './WelcomeScreen.styles';

export const ScreenWelcome: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Welcome Screen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="dark-solid">
      <IonContent scrollY={false}>
        <BgImageStyles
          src={`${S3_BUCKET_URL}/layout-own-ai-pool/welcome/background.jpg`}
          alt="Background"
        />
        <OverlayGradientStyles />

        <div className="content-wrapper">
          <LogoWithAppName className="app-logo" withCaption={false} />

          <PageTitleStyles align="center">
            Someone just arrived to
            <br /> clean your pool!
          </PageTitleStyles>

          <FooterContainerStyles>
            <OnboardingFooter
              onContinue={handleNextStep}
              buttonText="Open the door"
              buttonSize={'large'}
            />
          </FooterContainerStyles>
        </div>
      </IonContent>
    </PageStyles>
  );
};
